var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GmapMap',{ref:"map",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_setup.center,"zoom":7,"options":{
    streetViewControl: false,
  }}},[_c('GmapCluster',_vm._l((_vm.markers),function(marker,index){return _c('GmapMarker',{key:index,attrs:{"position":marker.position,"title":marker.title,"icon":_vm.activeMarker === index ? '/svg/marker-active.svg' : '/svg/marker.svg'},on:{"click":function($event){return _setup.setCenter(index)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }